var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArea = function SvgArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_31",
    "data-name": "Group 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.601,
    height: 21.472,
    viewBox: "0 0 26.601 21.472"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 26.601,
    height: 21.472,
    fill: "none",
    stroke: "#cfded7",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    y2: 12.408,
    transform: "translate(13.448 0)",
    fill: "none",
    stroke: "#cfded7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    y2: 21.381,
    transform: "translate(0.589 0.028)",
    fill: "none",
    stroke: "#cfded7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_68",
    "data-name": "Line 68",
    y2: 21.381,
    transform: "translate(26.011 0.028)",
    fill: "none",
    stroke: "#cfded7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_69",
    "data-name": "Line 69",
    x2: 26.601,
    transform: "translate(0 20.904)",
    fill: "none",
    stroke: "#cfded7",
    strokeWidth: 1
  }))));
};

export { SvgArea as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iR3JvdXBfMzEiIGRhdGEtbmFtZT0iR3JvdXAgMzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyNi42MDEiIGhlaWdodD0iMjEuNDcyIiB2aWV3Qm94PSIwIDAgMjYuNjAxIDIxLjQ3MiI+CiAgPGRlZnM+CiAgICA8Y2xpcFBhdGggaWQ9ImNsaXAtcGF0aCI+CiAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfMTE3IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxMTciIHdpZHRoPSIyNi42MDEiIGhlaWdodD0iMjEuNDcyIiBmaWxsPSJub25lIiBzdHJva2U9IiNjZmRlZDciIHN0cm9rZS13aWR0aD0iMSIvPgogICAgPC9jbGlwUGF0aD4KICA8L2RlZnM+CiAgPGcgaWQ9Ikdyb3VwXzMwIiBkYXRhLW5hbWU9Ikdyb3VwIDMwIiBjbGlwLXBhdGg9InVybCgjY2xpcC1wYXRoKSI+CiAgICA8bGluZSBpZD0iTGluZV82NiIgZGF0YS1uYW1lPSJMaW5lIDY2IiB5Mj0iMTIuNDA4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMy40NDggMCkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2NmZGVkNyIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgICA8bGluZSBpZD0iTGluZV82NyIgZGF0YS1uYW1lPSJMaW5lIDY3IiB5Mj0iMjEuMzgxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjU4OSAwLjAyOCkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2NmZGVkNyIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgICA8bGluZSBpZD0iTGluZV82OCIgZGF0YS1uYW1lPSJMaW5lIDY4IiB5Mj0iMjEuMzgxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNi4wMTEgMC4wMjgpIiBmaWxsPSJub25lIiBzdHJva2U9IiNjZmRlZDciIHN0cm9rZS13aWR0aD0iMSIvPgogICAgPGxpbmUgaWQ9IkxpbmVfNjkiIGRhdGEtbmFtZT0iTGluZSA2OSIgeDI9IjI2LjYwMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAyMC45MDQpIiBmaWxsPSJub25lIiBzdHJva2U9IiNjZmRlZDciIHN0cm9rZS13aWR0aD0iMSIvPgogIDwvZz4KPC9zdmc+Cg==";